import { createSlice } from "@reduxjs/toolkit";
import { getCustomersAPI } from "../../api/customer";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const getCustomersSlice = createSlice({
  name: "getCustomers",
  initialState: data,
  reducers: {
   getCustomersSlice(state) {
      state.isLoading = true;
    },
   getCustomersSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getCustomersSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
   getCustomersSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const getCustomersHandler: any = (search:any,page:any,limit:any,selectedStatus:any,sort_by:any,sort_direction:any) => async (dispatch: any) => {
  try {
    dispatch(getCustomersAction.getCustomersSlice());
    const response: any = await getCustomersAPI(search,page,limit,selectedStatus,sort_by,sort_direction);
    
    dispatch(getCustomersAction.getCustomersSliceSuccess(response));
  } catch (e: any) {
    dispatch(getCustomersAction.getCustomersSliceFailure(e?.response?.data));
  }
};
export default getCustomersSlice.reducer;
export const getCustomersAction = getCustomersSlice.actions;
